import React, { Component } from 'react';
import { connect } from 'shalala';

import './Styles.css';
import { useStore } from '../../../store';
import Loading from '../../../facturotopia/loading/Loading';
import SwitchEmpresaListItem from './components/SwitchEmpresaListItem';

class SwitchEmpresasList extends Component {
  componentDidMount() {
    this.paginate(1);
  }

  componentWillUnmount() {
    this.props.reset();
  }

  paginate(page = 1) {
    this.props.paginate({
      page,
      include: 'config',
    });
  }

  handleOnPageChange = (page) => {
    this.paginate(page);
  };

  renderListItem = (item) => {
    const { onRowClick } = this.props;

    return (
      <SwitchEmpresaListItem
        key={item.id}
        data={item}
        onClick={onRowClick}
      />
    );
  };

  render() {
    const { data, busy } = this.props;

    if (busy) {
      return <Loading />;
    }

    return <div className="empresas-switch">{data.map(this.renderListItem)}</div>;
  }
}

const mapState = (state) => {
  return state.app.empresas.list;
};

const mapActions = (actions) => {
  return {
    reset: actions.app.empresas.list.reset,
    paginate: actions.app.empresas.list.paginate,
  };
};

export default connect(useStore, mapState, mapActions)(SwitchEmpresasList);
